import api from "@/lib/api";

const b64uToBuf = (s) => {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  const pad = s.length % 4 ? "=".repeat(4 - (s.length % 4)) : "";
  const bin = atob(s + pad);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  return buf.buffer;
};
const bufToB64u = (buf) => {
  const bytes = new Uint8Array(buf);
  let bin = "";
  bytes.forEach((b) => (bin += String.fromCharCode(b)));
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
const randChallenge = () => {
  const a = new Uint8Array(32);
  crypto.getRandomValues(a);
  return a.buffer;
};

export const biometricsSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential;

// Create a platform passkey and register it with the backend
export async function enableBiometrics(user) {
  const cred = await navigator.credentials.create({
    publicKey: {
      challenge: randChallenge(),
      rp: { name: "Redemption Academy", id: window.location.hostname },
      user: {
        id: new TextEncoder().encode(user.id || user.email),
        name: user.email,
        displayName: user.name || user.email,
      },
      pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
      authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required" },
      timeout: 60000,
    },
  });
  const credential_id = bufToB64u(cred.rawId);
  await api.post("/webauthn/register", { credential_id });
  return credential_id;
}

// Prompt the platform authenticator and log in
export async function loginWithBiometrics(email) {
  const { data } = await api.get(`/webauthn/available?email=${encodeURIComponent(email)}`);
  if (!data.has_credentials) throw new Error("No biometric credential is set up for this email.");
  const assertion = await navigator.credentials.get({
    publicKey: {
      challenge: randChallenge(),
      allowCredentials: data.credential_ids.map((id) => ({ id: b64uToBuf(id), type: "public-key" })),
      userVerification: "required",
      timeout: 60000,
      rpId: window.location.hostname,
    },
  });
  const credential_id = bufToB64u(assertion.rawId);
  const res = await api.post("/webauthn/login", { email, credential_id });
  return res.data;
}
